import React from 'react';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE, RedcatIconProps } from './RedcatIcon';

const RedcatMapPinGroupIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.88C9.65208 12.3867 10.8776 11.03 11.6766 9.81C12.4755 8.59 12.875 7.50667 12.875 6.56C12.875 5.10667 12.4044 3.91667 11.4633 2.99C10.5221 2.06333 9.36771 1.6 8 1.6C6.63229 1.6 5.47786 2.06333 4.53672 2.99C3.59557 3.91667 3.125 5.10667 3.125 6.56C3.125 7.50667 3.52448 8.59 4.32344 9.81C5.1224 11.03 6.34792 12.3867 8 13.88ZM8 16C5.81979 14.1733 4.19141 12.4767 3.11484 10.91C2.03828 9.34333 1.5 7.89333 1.5 6.56C1.5 4.56 2.15339 2.96667 3.46016 1.78C4.76693 0.593333 6.28021 0 8 0C9.71979 0 11.2331 0.593333 12.5398 1.78C13.8466 2.96667 14.5 4.56 14.5 6.56C14.5 7.89333 13.9617 9.34333 12.8852 10.91C11.8086 12.4767 10.1802 14.1733 8 16Z"
        fill={color}
      />
      <path
        d="M8.00016 9.6C8.54461 9.6 9.05572 9.48056 9.5335 9.24167C10.0113 9.00278 10.3891 8.65 10.6668 8.18333C10.2779 7.88333 9.8585 7.64444 9.4085 7.46667C8.9585 7.28889 8.48905 7.2 8.00016 7.2C7.51127 7.2 7.04183 7.28889 6.59183 7.46667C6.14183 7.64444 5.72238 7.88333 5.3335 8.18333C5.61127 8.65 5.98905 9.00278 6.46683 9.24167C6.94461 9.48056 7.45572 9.6 8.00016 9.6ZM8.00016 6.4C8.3335 6.4 8.61683 6.28333 8.85016 6.05C9.0835 5.81667 9.20016 5.53333 9.20016 5.2C9.20016 4.86667 9.0835 4.58333 8.85016 4.35C8.61683 4.11667 8.3335 4 8.00016 4C7.66683 4 7.3835 4.11667 7.15016 4.35C6.91683 4.58333 6.80016 4.86667 6.80016 5.2C6.80016 5.53333 6.91683 5.81667 7.15016 6.05C7.3835 6.28333 7.66683 6.4 8.00016 6.4Z"
        fill={color}
      />
    </svg>
  );
};

export default RedcatMapPinGroupIcon;
